import omit from 'lodash/omit';

import { SENDOUT_CREATION_FIELDS_MAP } from '../CreateSendoutDrawer/SendoutForm/SendoutForm.constants';

export const SWITCH_SENDOVER_TO_SENDOUT_TYPES = {
  WithMail: 'withMail',
  WithoutMail: 'withoutMail'
};

export const SENDOUT_CONVERSION_FIELDS_MAP = omit(SENDOUT_CREATION_FIELDS_MAP, ['Candidate']);
